// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { CERTIFICATION_MODULE, CERTIFICATION_URL } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { CertificationIndex, CertificationDetail, CertificationRegistration, CertificationRegistrationDetail } = lazily(
  () => import('pages/webpage/certification'),
)

const certificationRoutes: IRoute[] = [
  {
    path: CERTIFICATION_URL.INDEX,
    component: CertificationIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: CERTIFICATION_MODULE,
      requireAuth: false,
      attrs: {
        label: 'certification.certification',
      },
    },
  },
  {
    path: `${CERTIFICATION_URL.INDEX}/:certificationId`,
    component: CertificationDetail,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: CERTIFICATION_MODULE,
      requireAuth: false,
      attrs: {
        label: 'certification.certificationDetail',
      },
    },
  },
  {
    path: `${CERTIFICATION_URL.REGISTRATION}:certificationId/assessment/:assessmentId`,
    component: CertificationRegistration,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: CERTIFICATION_MODULE,
      requireAuth: true,
      attrs: {
        label: 'certification.schema.schema',
      },
    },
  },
  {
    path: `${CERTIFICATION_URL.REGISTRATION}:certificationId/assessment/:assessmentId/self-assessment/:competencyUnitId`,
    component: CertificationRegistrationDetail,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: CERTIFICATION_MODULE,
      requireAuth: true,
      attrs: {
        label: 'certification.selfAssessment.selfAssessment',
      },
    },
  },
]

export { certificationRoutes }
